<script>
export default {
     data() {
    return {
        smscode: null
    };
     },
}
</script>
<template>
    <div>
        <div class="row-fluid">
            <p class="m-auto">Thank you – we have now sent an SMS code to the lead client on your booking to verify.
                Please enter the code below and we will process your request.</p>
            <p><input type="text" class="vtd-form-control" placeholder="Enter code sent in SMS" id="smscode"
                    v-model="smscode"></p>
        </div>
        <div class="row">
            <div class="col-md-3">
            <button class="btn btn-success" @click="$emit('checkThenSend', smscode)">
                Submit
            </button>
            </div> 
            <div class="col-md-6"> 
            <button class="btn btn-info" @click="$emit('sendSMS')">Re-send SMS code</button>
            </div>
        </div>

    </div>

</template>